/** Overview page and its daily chart. */
export const overview = {
  eyebrow: "Overview",
  greeting: "Hi {name}",
  intro: "Balances, and activity for {merchant} over the chosen dates. Days start at 00:00 UTC.",
  summaryLabel: "Summary",
  totalAvailable: "Retained balance (available to collect)",
  reservedForPending: "{amount} reserved for pending payouts",
  deposits: "Deposits",
  depositsSub: { one: "{n} deposit · {fee} processing fee", other: "{n} deposits · {fee} processing fee" },
  payouts: "Payouts",
  payoutsSub: { one: "{n} payout · {fee} processing fee", other: "{n} payouts · {fee} processing fee" },
  periodLabel: "Totals for the chosen dates",
  swept: "Swept to vault",
  sweptSub: { one: "{n} deposit moved into your vault, after fees", other: "{n} deposits moved into your vault, after fees" },
  fees: "Processing fee (incl. gas)",
  feesSub: "Deposit and payout processing, including on-chain gas",
  byNetwork: "By network",
  network: "Network",
  balances: "Balances",
  stablecoinsNote: "Stablecoins counted 1:1 in USD totals",
  noAssetsTitle: "No assets enabled yet",
  noAssetsBody: "Balances appear here once a chain and token are set up for {merchant}. Our team does this during onboarding.",
  available: "Available",
  pendingPayouts: "Pending payouts",
  noFlow: "No deposits or payouts in these dates.",
  loadingOverview: "Loading overview",

  // Waiting for approval card
  waitingForApproval: "Waiting for approval",
  payoutsCount: { one: "{n} payout", other: "{n} payouts" },
  oldestFirst: "Oldest first",
  approverHint: "An owner or finance member approves these",
  toAddress: "to {address}",
  seeAll: "See all {n}",

  // 14-day chart
  chart: {
    title: "Daily activity",
    sub: "Daily volume in USD (UTC days)",
    legend: "Legend",
    deposits: "Deposits",
    payouts: "Payouts",
    showChart: "Show chart",
    showTable: "Show as table",
    tableCaption: "Deposits and payouts per day",
    day: "Day",
  },
};
